<template>
  <div class="Header-menu">
    <div class="Header-menu-black">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" router text-color="#999" active-text-color="var(--theme-color)">
        <el-menu-item index="/aboutUs">{{$t('solutions.menu.title1')}}</el-menu-item>
        <el-submenu index="/solutions">
          <template slot="title">{{$t('solutions.menu.title2')}}</template>
            <el-submenu index="2-4" class="pv">
              <template slot="title">{{$t('solutions.menu.title3')}}</template>
              <el-menu-item class="pv1" index="/solutions">{{$t('solutions.menu.title4')}}</el-menu-item>
              <el-menu-item index="/solutions/commercial">{{$t('solutions.menu.title5')}}</el-menu-item>
            </el-submenu>
          <el-menu-item index="/solutions/photovoltaic">{{$t('solutions.menu.title6')}}</el-menu-item>
          <el-menu-item index="/solutions/iac">{{$t('solutions.menu.title7')}}</el-menu-item>
          <el-menu-item index="/solutions/microGrid">{{$t('solutions.menu.title8')}}</el-menu-item>
        </el-submenu>
      
        <el-submenu index="/product" >
          <template slot="title">{{ $t('solutions.menu.title11') }}</template> 
          <!-- 英文版产品介绍，不动 -->
          <template v-if="isShowMenus">
            <el-menu-item index="/product/Inverters">Energy Storage Inverter</el-menu-item>
            <el-menu-item index="/product/Batteries">Battery</el-menu-item>
            <el-menu-item index="/product/PV">PV Module</el-menu-item>
            <!-- <el-menu-item index="/product/EV">EV Charger</el-menu-item> -->
            <el-menu-item class="hidden" index="/product/details" disabled></el-menu-item>
          </template>
          <template v-else>
            <el-menu-item index="/charging">{{$t('solutions.menu.title12')}}</el-menu-item>
            <el-menu-item index="/operationsPlatform">{{$t('solutions.menu.title13')}}</el-menu-item>
          </template>
        </el-submenu>
        <el-menu-item index="/cases">{{$t('solutions.menu.title9')}}</el-menu-item>
        <el-menu-item index="/FAQs" v-show="isShowMenus">FAQs</el-menu-item>
        <el-menu-item index="/contact">{{$t('solutions.menu.title10')}}</el-menu-item>
      </el-menu>
    </div>
    <div class="menu" @click="showAsideMenu()" type="primary">
      <img v-lazy="require('@/assets/images/menu.png')" alt="" > 
    </div>
    <el-drawer
      :append-to-body="true"
      :visible.sync="drawer"
      size="75%"
      >
      <div class="menu-list-box">
        <div v-for="(item,index) in menus" :key="index" :index="item.path" @click="toPage1(item.path)">
        <li v-show="(isShowMenus && item.mark!=='ProductByZh') || item.isShow  || (item.mark==='ProductByZh' && !isShowMenus)" >
          <div class="frist-menu" :class="activeTab==item.path?'activeTab':''">{{ item.name }}</div>
          <div class="secondary-menu" v-for="(item1,index) in item.children" :key="index" @click="toPage(item1.path)">
            <span :class="activeTab==item1.path?'activeTab':''">{{item1.name}}</span>
          </div>
        </li>
        </div>

      </div>
    </el-drawer>
  </div>
</template>

<script>

export default {
  data() {
    return {
      activeIndex: this.$route.meta.activeMenu || this.$route.path,
      activeTab: '/aboutUs',
      drawer: false,
      isShowMenus: false,
      menus: [
        { isShow: true, name: this.$t('solutions.menu.title1'),path: '/aboutUs'},
        { isShow: false,mark:'ProductByZh', name: this.$t('solutions.menu.title11'),path: '/product',children: [{name: this.$t('solutions.menu.title12'),path:'/charging'},{name: this.$t('solutions.menu.title13'),path:'/operationsPlatform'} ]},
        { isShow: true, name: this.$t('solutions.menu.title2'),path: '/solutions',children: [{name: this.$t('solutions.menu.title4'),path:'/solutions'},{name: this.$t('solutions.menu.title5'),path:'/solutions/commercial'},{name: this.$t('solutions.menu.title6'),path:'/solutions/photovoltaic'},{name: this.$t('solutions.menu.title7'),path:'/solutions/iac'},{name: this.$t('solutions.menu.title8'),path:'/solutions/microGrid'}]},
        { isShow: false, name: 'PRODUCT',path: '/product',children: [{name:'Energy Storage Inverter',path:'/product/Inverters'},{name:'Battery',path:'/product/Batteries'},{name:'PV Module',path:'/product/PV'}]},
        { isShow: true, name: this.$t('solutions.menu.title9'),path: '/cases'},
        { isShow: false, name: 'FAQs',path: '/FAQs'},
        { isShow: true, name: this.$t('solutions.menu.title10'),path: '/contact'},
      ]
    }
  },
  watch: {
    $route(val) {
      this.activeIndex = val.meta.activeMenu || val.path
    }
  },
  mounted(){
    console.log(localStorage.getItem('lang'))
    if(localStorage.getItem('lang') == 'en') {
      this.isShowMenus = true
    }else {
      this.isShowMenus = false
    }
  },
  methods: {
    showAsideMenu() {
      this.drawer = true
    },
    toPage(i) {
      this.$router.push({path: i})
      this.drawer = false
      this.activeTab = i
    },
    toPage1(i) {
      if((i== '/FAQs') || (i== '/contact') || (i== '/cases') || (i== '/aboutUs')) {
        this.$router.push({path: i})
        this.drawer = false
        this.activeTab = i
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.Header-menu-black{
  .el-menu{
    background: none;
    width: 100%;
  }
  .el-menu.el-menu--horizontal{
    border: none;
  }
}
.Header-menu-black .el-menu--horizontal > .el-menu-item {
  letter-spacing: 0.5px;
  font-size: 13px;
  text-transform: uppercase;
  background: transparent;
}

.activeTab {
  color: var(--theme-color);
}

.menu {
  margin-left: 130px;
}

.menu-list-box {
  .frist-menu {
    margin: 10px 0;
  }
  .secondary-menu {
    color: #ccc;
    line-height: 1.5;
    font-size: 14px;
  }
}
.el-menu-item:hover {
	color:white !important;
  background: var(--theme-color) !important;
}

.pv > :hover {
  background: var(--theme-color) !important;
	color:white !important;
}

.el-submenu > :hover {
  background: var(--theme-color) !important;
	color:white !important;
}

.hidden {
  display: none;
}

@media screen and (min-width: 980px) {
  .menu {
    display: none
  }
}
@media screen and (max-width: 980px) {
  .Header-menu-black {
    display: none
  }
  .Header-menu-pc {
    display: none
  }
}

</style>

